import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cmp-card-body',
  template: `<div  [class]="CustomClass">
  <ng-content></ng-content>
</div>

`,
  styles: [``]
})
export class CardBodyComponent implements OnInit {

  @Input() class_custom: any;

  constructor() {
  }

  ngOnInit() {
  }

  get CustomClass() {
    let retorno = 'card-body ';
    if (this.class_custom) {
      retorno += this.class_custom;
    }
    return retorno;
  }
}
